import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { RestApiService } from '../common-app/service/rest-api.service';
import { Kvaw1000Vo } from './kvaw1000.vo';
import { DateUtil } from '../common-app/util/date-util';

/**
 * サーバとの通信を行う。
 * @see WebAPI仕様_KVAW1000（市区郡町村一覧取得）.xlsx
 */
@Injectable()
export class Kvaw1000Service {

  /** 検索対象 */
  private static TARGET = 'kvaw1000';

  constructor(
    private restApiService: RestApiService,
  ) { }

  /**
   * 市区町村一覧を検索する
   *
   * @param atskFknCd 都道府県コード
   */
  searchMunicipality(atskFknCd?: string): Observable<Kvaw1000Vo> {
    const param = {};
    if (atskFknCd) {
      param['atskFknCd'] = atskFknCd;
    }
    return this.restApiService.search<Kvaw1000Vo>(Kvaw1000Service.TARGET, param);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/kvaw1000.service.ts